// Public client subscriptions only; no private credentials or stored personal data.
class OleCartWhatsAppOptin extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.saved = {};
    this.querySelector('[data-submit]')?.addEventListener('click', () => this.subscribe());
    const checkbox = this.querySelector('[data-consent]');
    checkbox?.addEventListener('change', () => {
      const field = this.querySelector('[data-phone-field]');
      if (field) field.hidden = !checkbox.checked;
    });
  }
  async subscribe() {
    if (this.busy) return;
    const en = this.dataset.locale === 'en';
    const emailInput = this.querySelector('[data-email]');
    const phoneInput = this.querySelector('[data-phone]');
    const emailConsent = this.querySelector('[data-email-consent]');
    const waConsent = this.querySelector('[data-consent]');
    const status = this.querySelector('[data-status]');
    const button = this.querySelector('[data-submit]');
    const email = emailInput.value.trim().toLowerCase();
    const emailWanted = emailConsent.checked;
    const waWanted = this.dataset.whatsapp === 'true' && waConsent?.checked === true;
    if (!emailWanted && !waWanted) {
      status.textContent = en ? 'Choose how you want to receive messages.' : 'Elige cómo quieres recibir mensajes.';
      emailConsent.focus(); return;
    }
    if (!email || !emailInput.checkValidity()) {
      status.textContent = en ? 'Enter a valid email address.' : 'Introduce un email válido.';
      emailInput.focus(); return;
    }
    const rawPhone = phoneInput?.value.trim() || '';
    const phone = '+' + rawPhone.replace(/\D/g, '');
    if (waWanted && (!rawPhone.startsWith('+') || !/^\+[1-9]\d{7,14}$/.test(phone))) {
      status.textContent = en ? 'Include the country code, for example +34.' : 'Incluye el prefijo del país, por ejemplo +34.';
      phoneInput.focus(); return;
    }
    if (waWanted && phone.startsWith('+1')) {
      status.textContent = en ? 'For this number, please choose email reminders instead.' : 'Para este número, elige los recordatorios por email.';
      return;
    }
    if (this.dataset.preview !== 'false') {
      status.textContent = en ? 'Preview: no subscription was sent.' : 'Vista previa: no se ha enviado ninguna solicitud.';
      return;
    }
    const company = this.dataset.company;
    const lists = {email: this.dataset.emailList, whatsapp: this.dataset.whatsappList};
    const requested = [emailWanted ? 'email' : null, waWanted ? 'whatsapp' : null].filter(Boolean);
    if (!/^[A-Za-z0-9]{6}$/.test(company || '') || requested.some(c => !/^[A-Za-z0-9]{6}$/.test(lists[c] || ''))) {
      status.textContent = en ? 'Please try again later.' : 'Inténtalo de nuevo más tarde.';
      return;
    }
    this.busy = true; button.disabled = true;
    status.textContent = en ? 'Saving your request…' : 'Guardando tu solicitud…';
    const failed = [];
    for (const channel of requested) {
      if (this.saved[channel]) continue;
      const timestamp = new Date().toISOString();
      const source = this.dataset.source;
      const attributes = {
        email,
        properties: {
          cart_consent_source: source,
          cart_consent_version: 'cart-optin-v2-2026-10-12',
          cart_consent_locale: en ? 'en' : 'es',
          cart_consent_surface: this.dataset.surface,
          ['cart_' + channel + '_consent_at']: timestamp,
          ['cart_' + channel + '_consent_text']: this.querySelector(channel === 'email' ? '[data-email-text]' : '[data-whatsapp-text]').textContent.trim()
        },
        subscriptions: {[channel]: {marketing: {consent: 'SUBSCRIBED'}}}
      };
      if (channel === 'whatsapp') attributes.phone_number = phone;
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST', mode: 'cors', credentials: 'omit',
          headers: {'Content-Type': 'application/json', revision: '2025-10-15'},
          body: JSON.stringify({data: {
            type: 'subscription',
            attributes: {custom_source: source, profile: {data: {type: 'profile', attributes}}},
            relationships: {list: {data: {type: 'list', id: lists[channel]}}}
          }})
        });
        if (!response.ok) throw new Error('request_not_accepted');
        this.saved[channel] = true;
      } catch { failed.push(channel); }
    }
    if (Object.keys(this.saved).length) {
      emailInput.disabled = true;
      if (phoneInput && this.saved.whatsapp) phoneInput.disabled = true;
      if (this.saved.email) emailConsent.disabled = true;
      if (this.saved.whatsapp && waConsent) waConsent.disabled = true;
      try {
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true) {
          const identity = this.saved.whatsapp ? {$email: email, $phone_number: phone} : {$email: email};
          (window.klaviyo = window.klaviyo || []).push(['identify', identity]);
        }
      } catch { /* No personal data in logs or browser storage. */ }
    }
    status.textContent = failed.length
      ? (en ? 'We could not save every choice. Try again; saved choices will not be submitted again.' : 'No pudimos guardar todas las opciones. Inténtalo de nuevo; no repetiremos las opciones guardadas.')
      : (en ? 'Request received. Check your email or WhatsApp and confirm your subscription if requested.' : 'Solicitud recibida. Revisa tu email o WhatsApp y confirma tu inscripción si se solicita.');
    this.busy = false; button.disabled = !failed.length;
  }
}
if (!customElements.get('ole-cart-whatsapp-optin')) customElements.define('ole-cart-whatsapp-optin', OleCartWhatsAppOptin);
